import type { PropsWithChildren } from 'react'
import * as React from 'react'
import clsx from 'clsx'
import styled from 'styled-components'

export const _TooltipTriggerElement = styled.span`
  &:not(.disabled) {
    cursor: pointer;
  }
  &.force-pointer-events {
    pointer-events: auto;
  }
`

interface Props {
  className?: string
  disabled?: boolean
  forcePointerEvents?: boolean
  ref?: React.Ref<HTMLSpanElement>
}

function _TooltipTrigger(props: PropsWithChildren<Props>) {
  const { children, className, disabled, forcePointerEvents, ref } = props

  return <_TooltipTriggerElement
    ref={ref}
    className={clsx(className, { disabled, 'force-pointer-events': forcePointerEvents })}
  >
    {children}
  </_TooltipTriggerElement>
}

export default _TooltipTrigger
